'use client'

import MUIStack from '@mui/material/Stack'
import MUIBox from '@mui/material/Box'
import { ChatMessage } from '@repo/ui/ChatMessage'
import { ChatForm } from '@repo/ui/ChatForm'

interface Message {
  id: string | number
  message: string
  senderUsername: string
  timestamp: string
}

interface ChatProps {
  messages: Message[]
  sendHandler: (message: string) => void
  onEditMessage?: (messageId: string | number, newMessage: string) => void
  onDeleteMessage?: (messageId: string | number) => void
}

export const Chat = ({ messages, sendHandler, onEditMessage, onDeleteMessage }: ChatProps) => {
  return (
    <MUIStack
      data-testid="Chat"
      direction="column"
      sx={{
        height: '100%',
        width: '100%'
      }}
    >
      <MUIBox
        sx={{
          flex: 1,
          overflowY: 'auto',
          padding: '16px'
        }}
      >
        <MUIStack direction="column" spacing={2} sx={{ mb: 4 }}>
          {messages.map((msg) => (
            <ChatMessage
              key={msg.id}
              message={msg.message}
              senderUsername={msg.senderUsername}
              timestamp={msg.timestamp}
              onEdit={onEditMessage ? (newMessage: string) => onEditMessage(msg.id, newMessage) : undefined}
              onDelete={onDeleteMessage ? () => onDeleteMessage(msg.id) : undefined}
            />
          ))}
        </MUIStack>
        <ChatForm onSend={sendHandler} />
      </MUIBox>
    </MUIStack>
  )
}
